module.exports = __webpack_public_path__ + "static/media/df (3).e54acc70.jpg";